import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useFormSchema = () => {
  const { t } = useTranslation('translation');

  const organizationSmallFormSchema = z.object({
    title: z
      .string()
      .min(1, t('common.formErrors.required'))
      .max(64, t('common.formErrors.stringMaxLen', { max: 64 })),
  });

  return organizationSmallFormSchema;
};
